import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FlaggKomponent} from "../flagg/flagg";
import {Lokaleinformasjon} from "felles-ng2/tjenester/i18n/GjeldendeLokale";
import {Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {erStreng} from "felles-ng2/støttefunksjoner/strenger";
import {Språk} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";

const debug = initDebugger('LokaleKomponent');

@Component({
    selector: 'lokale',
    templateUrl: 'lokale.html',
    styleUrl: 'lokale.scss',
    imports: [
        FlaggKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LokaleKomponent {

    lokale = input.required<Lokaleinformasjon | Språk>();
    stil = input<'flaggOgTekst' | 'flagg'>('flaggOgTekst');

    lokaleSomLokaleinformasjon = computed(() => this.somLokaleinformasjon());
    lokaleSomBrukerrettetStreng = computed(() => this.lokaleSomLokaleinformasjon().somBrukerrettetStreng(this.oversettelser));

    constructor(private oversettelser: Oversettelser) {
    }

    private somLokaleinformasjon(): Lokaleinformasjon {
        if (erStreng(this.lokale())) return Lokaleinformasjon.fraJavaLocale(this.lokale() as Språk);
        return this.lokale() as Lokaleinformasjon;
    }
}
